module.exports = __webpack_public_path__ + "img/tyr-rec.b909adec.webp";